'use client';
import React from 'react';

export const IqviaLogo = (props) => (
  <svg
    width="136"
    height="24"
    viewBox="0 0 136 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M57.7181 0.0142704C51.6269 0.334074 46.931 5.56101 47.2504 11.6654C47.5695 17.7695 52.7847 22.4755 58.876 22.1559C59.7615 22.109 60.6163 21.9558 61.4318 21.7145L61.4403 21.7107L62.2696 23.2977C62.6044 23.9383 63.3939 24.1857 64.0331 23.8505C64.6723 23.5148 64.9192 22.7233 64.5841 22.0827L63.8459 20.6699C67.316 18.6441 69.5681 14.7928 69.3437 10.5048C69.0246 4.40039 63.809 -0.305893 57.7181 0.0142704ZM62.6328 18.3485L61.6909 16.5458C61.3561 15.9052 60.5666 15.6578 59.9274 15.9938C59.2882 16.3289 59.0413 17.1203 59.3761 17.7606L60.1969 19.332L60.1861 19.3358C59.718 19.4436 59.2353 19.5146 58.7391 19.5404C54.087 19.7853 50.1035 16.1908 49.8598 11.5283C49.6158 6.86576 53.2025 2.87398 57.8546 2.6291C62.5071 2.38488 66.4903 5.97928 66.7343 10.6418C66.9035 13.8767 65.2279 16.7865 62.6328 18.3485Z"
        fill="#00A3E0"
      />
      <path
        d="M40.7254 22.1089C40.0039 22.1089 39.4189 21.5226 39.4189 20.7996V1.37034C39.4189 0.647265 40.0039 0.0610128 40.7254 0.0610128C41.4469 0.0610128 42.0319 0.647265 42.0319 1.37034V20.7996C42.0319 21.5226 41.4469 22.1089 40.7254 22.1089Z"
        fill="#00A3E0"
      />
      <path
        d="M102.762 22.1089C102.041 22.1089 101.456 21.5226 101.456 20.7996V1.37034C101.456 0.647265 102.041 0.0610133 102.762 0.0610133C103.484 0.0610133 104.069 0.647265 104.069 1.37034V20.7996C104.069 21.5226 103.484 22.1089 102.762 22.1089Z"
        fill="#005587"
      />
      <path
        d="M84.1493 22.1089C84.1477 22.1089 84.1461 22.1089 84.1444 22.1089C83.6601 22.1068 83.2165 21.8368 82.9918 21.4072L72.8409 1.97757C72.5064 1.33698 72.7534 0.545887 73.3926 0.210372C74.0321 -0.125144 74.8212 0.122646 75.1557 0.762843L84.1604 17.9981L93.3416 0.754038C93.6813 0.11574 94.4733 -0.124783 95.1093 0.215348C95.7459 0.555479 95.9866 1.34887 95.6469 1.9869L85.302 21.4159C85.0747 21.8429 84.6318 22.1089 84.1493 22.1089Z"
        fill="#005587"
      />
      <path
        d="M125.591 17.7014H119.294C118.572 17.7014 117.987 17.115 117.987 16.3921C117.987 15.669 118.572 15.0828 119.294 15.0828H125.591C126.313 15.0828 126.898 15.669 126.898 16.3921C126.898 17.115 126.313 17.7014 125.591 17.7014Z"
        fill="#005587"
      />
      <path
        d="M132.663 22.1091C132.192 22.1091 131.738 21.8538 131.504 21.4071L122.499 4.17208L113.319 21.4158C112.979 22.0541 112.187 22.2955 111.551 21.9548C110.914 21.6143 110.673 20.8215 111.013 20.1832L121.358 0.75401C121.586 0.325532 122.03 0.0456313 122.515 0.0609832C123 0.0631436 123.443 0.333094 123.668 0.762816L133.819 20.1924C134.154 20.833 133.907 21.6245 133.268 21.9595C133.074 22.0612 132.867 22.1091 132.663 22.1091Z"
        fill="#005587"
      />
      <path
        d="M31.8424 18.4673H25.4295C24.981 19.2833 24.4624 20.0322 23.8824 20.6973H31.8424C32.4541 20.6973 32.9546 20.195 32.9546 19.5819C32.9546 18.9688 32.4541 18.4673 31.8424 18.4673Z"
        fill="#005587"
      />
      <path
        d="M31.8424 14.2191H26.9592C26.8056 14.992 26.5958 15.7368 26.3392 16.448H31.8424C32.4541 16.448 32.9546 15.9465 32.9546 15.3334C32.9546 14.7203 32.4541 14.2191 31.8424 14.2191Z"
        fill="#005587"
      />
      <path
        d="M31.8423 9.96976H27.235C27.2571 10.317 27.2713 10.6671 27.2713 11.0212C27.2713 11.4186 27.2549 11.811 27.2275 12.1997H31.8423C32.4541 12.1997 32.9546 11.6982 32.9546 11.0845C32.9546 10.4714 32.4541 9.96976 31.8423 9.96976Z"
        fill="#005587"
      />
      <path
        d="M31.8423 5.72088H26.3841C26.6341 6.43296 26.8354 7.1783 26.9822 7.95044H31.8423C32.4541 7.95044 32.9546 7.44897 32.9546 6.83587C32.9546 6.22275 32.4541 5.72088 31.8423 5.72088Z"
        fill="#005587"
      />
      <path
        d="M31.8424 1.4723H23.9901C24.5568 2.14003 25.0642 2.88739 25.5007 3.70203H31.8424C32.4541 3.70203 32.9546 3.20039 32.9546 2.5873C32.9546 1.97417 32.4541 1.4723 31.8424 1.4723Z"
        fill="#005587"
      />
      <path
        d="M10.6424 19.5819C10.6424 18.9688 11.1429 18.4673 11.7546 18.4673H7.37259C6.76091 18.4673 6.26013 18.9688 6.26013 19.5819C6.26013 20.195 6.76091 20.6973 7.37259 20.6973H11.7546C11.1429 20.6973 10.6424 20.195 10.6424 19.5819Z"
        fill="#00A3E0"
      />
      <path
        d="M25.4295 18.4673H11.7549C11.1432 18.4673 10.6424 18.9688 10.6424 19.5819C10.6424 20.195 11.1432 20.6973 11.7549 20.6973H23.8824C24.4624 20.0322 24.981 19.2833 25.4295 18.4673Z"
        fill="#005587"
        fillOpacity="0.5"
      />
      <path
        d="M7.53703 15.5702C7.38776 14.8548 7.93574 14.2191 8.62447 14.2191H4.24219C3.63052 14.2191 3.13013 14.7203 3.13013 15.3334C3.13013 15.9465 3.63052 16.448 4.24219 16.448H8.66082C8.13005 16.448 7.64573 16.0906 7.53703 15.5702Z"
        fill="#00A3E0"
      />
      <path
        d="M26.9592 14.2191H8.62446C7.93574 14.2191 7.38776 14.8548 7.53703 15.5702C7.64573 16.0906 8.13044 16.448 8.66121 16.448H26.3392C26.5958 15.7368 26.8056 14.992 26.9592 14.2191Z"
        fill="#005587"
        fillOpacity="0.5"
      />
      <path
        d="M4.4069 11.3213C4.25764 10.6063 4.80562 9.96976 5.49447 9.96976H1.11257C0.500783 9.96976 0 10.4714 0 11.0845C0 11.6982 0.500783 12.1997 1.11257 12.1997H5.53083C5.00006 12.1997 4.51574 11.8422 4.4069 11.3213Z"
        fill="#00A3E0"
      />
      <path
        d="M4.4069 11.3213C4.51573 11.8422 5.00005 12.1997 5.53082 12.1997H27.2275C27.2549 11.811 27.2713 11.4186 27.2713 11.0212C27.2713 10.6671 27.2571 10.317 27.235 9.96976H5.49447C4.80561 9.96976 4.25763 10.6063 4.4069 11.3213Z"
        fill="#005587"
        fillOpacity="0.5"
      />
      <path
        d="M5.93349 6.83587C5.93349 6.22275 6.43427 5.72088 7.04594 5.72088H2.66353C2.052 5.72088 1.55109 6.22275 1.55109 6.83587C1.55109 7.44897 2.052 7.95044 2.66353 7.95044H7.04594C6.43427 7.95044 5.93349 7.44897 5.93349 6.83587Z"
        fill="#00A3E0"
      />
      <path
        d="M26.3841 5.72088H7.04593C6.43426 5.72088 5.93387 6.22275 5.93387 6.83587C5.93387 7.44897 6.43426 7.95044 7.04593 7.95044H26.9822C26.8354 7.1783 26.6341 6.43296 26.3841 5.72088Z"
        fill="#005587"
        fillOpacity="0.5"
      />
      <path
        d="M14.0131 2.82383C13.8639 2.1087 14.412 1.4723 15.1008 1.4723H10.7188C10.107 1.4723 9.60635 1.97417 9.60635 2.5873C9.60635 3.20039 10.107 3.70203 10.7188 3.70203H15.1376C14.6068 3.70203 14.122 3.34438 14.0131 2.82383Z"
        fill="#00A3E0"
      />
      <path
        d="M23.99 1.4723H15.1009C14.412 1.4723 13.8639 2.1087 14.0132 2.82383C14.122 3.34438 14.6068 3.70203 15.1376 3.70203H25.5007C25.0642 2.88739 24.5568 2.14003 23.99 1.4723Z"
        fill="#005587"
        fillOpacity="0.5"
      />
    </g>
  </svg>
);

export default IqviaLogo;
